import {h, Fragment} from "preact"
import { useActions, useAppState, useSizeOptions } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"

export default function BottomToolbar() {
    const { query, response } = useAppState();
    const { updateSearch } = useActions();

    const { to, total } = useSizeOptions(sizes, defaultConfig.serpSize)
   

    const loadMore = () => {
        const newProductsLoaded = query.products.size + 24;
        updateSearch({ products: {
            size: newProductsLoaded
        }})
    }

    return (
        <div id="isp_load_more" class="ns-load-more">
            {to < total && <a href="#/" id="isp_load_more_button" onClick={loadMore}>Load More Results</a> }
        </div>
    )
}
